// extracted by mini-css-extract-plugin
export var borderRadius = "_am-4";
export var large = "_am-3";
export var logoContainer = "_am-0";
export var nameLogo = "_am-2";
export var small = "_am-1";